export const RETURN_CODES_DEFAULT_TABLE_LIMIT = 10;
export const RETURN_CODES_GRACE_PERIOD_MIN_VALUE = 0;
export const RETURN_CODES_GRACE_PERIOD_MAX_VALUE = 180;
export const RETURN_POSTERS_ZIP_FILE_NAME = 'return-posters';
